import { SupplyCategory } from '@ebalance/proto/bfftypes/v1/supply_category_pb'

/** UIのカテゴリ選択肢。保存フィルタも同じ集合だけを復元する。 */
export const CATEGORY_OPTIONS = [
  {
    value: SupplyCategory.BILATERAL,
    labelKey: 'page:supply48Data.filter.categoryBilateral',
  },
  {
    value: SupplyCategory.MARKET,
    labelKey: 'page:supply48Data.filter.categoryMarket',
  },
  {
    value: SupplyCategory.FUTURES,
    labelKey: 'page:supply48Data.filter.categoryFutures',
  },
] as const
